import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './../node_modules/bulma/css/bulma.css';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

import { domain, clientId } from "./auth/auth_config.json";
import { Auth0Plugin } from "./auth";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.use(VueToast);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import VuePwaInstallPlugin from "vue-pwa-install";
Vue.use(VuePwaInstallPlugin);

import Trend from 'vuetrend';
Vue.use(Trend);

import VueOffline from 'vue-offline'
Vue.use(VueOffline);

import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).local().format('MM/DD/YYYY');
  }
})
Vue.filter('formatDateSmall', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).local().format('MM/DD');
  }
})
Vue.filter('formatDateTime', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).format('MM/DD/YYYY HH:mm');
  }
})
Vue.filter('formatDateTimeAmPm', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).format('MM/DD/YYYY hh:mm A');
  }
})
Vue.filter('formatDateTimeLong', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).format('MMM DD hh:mm A');
  }
})
Vue.filter('formatDateTimeLongFull', function(value) {
  if (value) {
    //UTC datetime to Local date time
    return moment(String(value)).format('MMMM DD, YYYY');
  }
})

Vue.filter('formatAverage', function(value) {
  if (value) {
    var val = parseFloat(value).toFixed(2);
    return val;
  }
})

import Vuex from 'vuex'
Vue.use(Vuex);

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false


export default class playerClass  {
  constructor(id, nickname, name, given_name, family_name, email, picture, editable = false) {
    this.id = id;
    this.nickname = nickname;
    this.name = name;
    this.given_name = given_name;
    this.family_name = family_name;
    this.email = email;
    this.emailVisible = false;
    this.picture = picture;
    this.selectedForFinals = false;
    this.axe = "";
    this.editable = editable;
  }
}

Vue.prototype.$playerClass = playerClass;

/*
export default class Axes2Player {
  constructor(id, nickname, name, given_name, family_name, email, picture, editable = false){
    this.id = id;
    this.nickname = nickname;
    this.name = name;
    this.given_name = given_name;
    this.family_name = family_name;
    this.email = email;
    this.emailVisible = false;
    this.picture = picture;
    this.selectedForFinals = false;
    this.axe = "";
    this.editable = editable;
  }
}
*/

const store = new Vuex.Store({
  state: {
      location: null
  },
  getters: {
    getLocation() {
      return store.state.location;
    }
  },
  mutations: {
    setLocation(state, location) {
        store.state.location = location;
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



